import React, { useCallback, useMemo, useState } from 'react';

import { FontAwesomeIcon, Input } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

import { schemaUtils } from '../../../integration-test-modal.utils';
import { FieldIcon } from '../schema-form-field.constants';
import { IPasswordFieldProps } from '../schema-form-field.types';

export const PasswordField: React.FC<IPasswordFieldProps> = ({
  name,
  path,
  property,
  value,
  onChange,
  required
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const fieldLabel = useMemo(
    () => schemaUtils.formatFieldLabel(name, property.title),
    [property.title, name]
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(path, e.target.value);
    },
    [path, onChange]
  );

  const handleTogglePasswordVisibility = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const placeholderValue = useMemo(() => {
    if (property.default === undefined) {
      return undefined;
    }
    return String(property.default);
  }, [property.default]);

  const passwordVisibilityIcon = useMemo(() => {
    if (showPassword) {
      return FieldIcon.EYE_SLASH;
    }
    return FieldIcon.EYE;
  }, [showPassword]);

  const inputType = useMemo(() => {
    if (showPassword) {
      return 'text';
    }
    return 'password';
  }, [showPassword]);

  return (
    <Input
      type={inputType}
      label={fieldLabel}
      isRequired={required}
      description={property.description}
      value={String(value ?? '')}
      onChange={handleInputChange}
      placeholder={placeholderValue}
      minLength={property.minLength}
      maxLength={property.maxLength}
      readOnly={property.readOnly}
      required={required}
      className={cn('pr-10', property.readOnly && 'bg-base-muted')}
      rightIcon={
        <FontAwesomeIcon
          icon={passwordVisibilityIcon}
          onClick={handleTogglePasswordVisibility}
        />
      }
      rightIconStyles="cursor-pointer text-base-mutedForeground"
    />
  );
};
